import React from 'react'
import { useSelector } from 'react-redux'
import ClanLanding from './ClanLanding'
import { useIsTimestampExpired } from 'hooks/useIsTimestampExpired'

const ClanLandingContainer = () => {
    const { visibleStartDate, visibleEndDate } = useSelector(state => state.strongholdManeuvers)
    const isVisibleStartExpired = useIsTimestampExpired(visibleStartDate || 0)
    const isVisibleEndExpired = useIsTimestampExpired(visibleEndDate || 0)
    const isManeuversEventVisible = isVisibleStartExpired && !isVisibleEndExpired

    return <ClanLanding isManeuversEventVisible={isManeuversEventVisible}/>
}

export default ClanLandingContainer



// WEBPACK FOOTER //
// ./containers/ClanLanding/ClanLandingContainer.jsx